
define('ldsh!modules/editor/templates/elements/form', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form\n  id="lpg-form"\n  name="lpg-form-main"\n  action="' +
((__t = ( confirmationUrl )) == null ? '' : __t) +
'"\n  method="post"\n  role="form"\n  onsubmit="return false"\n  ';
 if (googleRecaptchaData) { ;
__p += '\n    data-captcha="googleReCaptcha"\n    data-captcha-key="' +
((__t = ( googleRecaptchaData.siteKey )) == null ? '' : __t) +
'"\n  ';
 } ;
__p += '>\n\n  <input type="hidden" name="__variants_id" id="__variants_id" value="' +
((__t = ( variantId )) == null ? '' : __t) +
'" />\n  ';
 if (externalConfirmationUrl) {;
__p += '\n      <input type="hidden" name="__external_confirmation_url__" value="' +
((__t = ( externalConfirmationUrl )) == null ? '' : __t) +
'" />\n      <input type="hidden" name="__confirmation_sendparams__" value="' +
((__t = ( confirmationSendParams )) == null ? '' : __t) +
'" />\n  ';
};
__p += '\n  ';
 if (skipConversion) {;
__p += '\n  <input type="hidden" name="__skipconversion__" id="__skipconversion__" value="true" />\n  ';
};
__p += '\n  ';
 if (reqConversion) {;
__p += '\n  <input type="hidden" name="__reqconversion__" id="__reqconversion_" value="' +
((__t = ( reqConversion )) == null ? '' : __t) +
'" />\n  ';
};
__p += '\n  ';
 if (successMessage) {;
__p += '\n  <input type="hidden" name="__successmessage__" id="__successmessage_" value="' +
((__t = ( escapedSuccessMessage )) == null ? '' : __t) +
'" />\n  ';
};
__p += '\n  <input type="hidden" name="__hash__" id="__hash__" value="{{hash}}" />\n  ';
 if (isSingleStep || executionStep) {;
__p += '\n  <input type="hidden" name="__exec_conversion__" id="__exec_conversion__" value="true" />\n  ';
};
__p += '\n\n  <input type="hidden" name="variants_id" value="{{variants_id}}" />\n  <input type="hidden" name="visits_id" value="" />\n  <input type="hidden" name="pages_id" value="{{pages_id}}" />\n  <div class="js-fields"></div>\n  <div class="editor-form-group form-group form-group-col one-whole">\n    <!-- <label class="control-label col-sm-3"></label> -->\n    <div class="col-sm-12 js-control js-submit-wrapper">\n      <button id="submit" type="submit" class="btn btn-default js-submit" form="lpg-form" />\n    </div>\n  </div>\n</form>\n\n';
 if (isCorreoDirectAvailable && isCorreoDirectActive) {;
__p += '\n<!--CORREO DIRECT-->\n<div id=\'sponsors_config\' style=\'display:none\'>\n  <form name="INTEGRATION_ConfigForm" class="sponsors_config" onsubmit="return false">\n    <input type="hidden" name="ClientSubmitButton" value="button">\n    <input type="hidden" name="FormName" value="lpg-form-main">\n    <input type="hidden" name="Language" value="' +
((__t = ( countryId )) == null ? '' : __t) +
'">\n    <input type="hidden" name="Affiliate" value="' +
((__t = ( idaf )) == null ? '' : __t) +
'">\n    ';
 _.each(this.model.getCompatData(), function(compat) { ;
__p += '\n      <input type="hidden" name="' +
((__t = ( 'COMPAT_' + compat.name )) == null ? '' : __t) +
'" value="' +
((__t = ( compat.name )) == null ? '' : __t) +
'" />\n    ';
 }) ;
__p += '\n  </form>\n  <form name="INTEGRATION_Personal" class="sponsors_config" onsubmit="return false">\n    <input type="hidden" name="1" value="ItemperRow">\n  </form>\n  <form name="INTEGRATION_Categories" class="sponsors_config" onsubmit="return false">\n    <input type="hidden" name="4" value="ItemperRow">\n  </form>\n  ';
 _.each(this.model.getCompatData(), function(compat){ ;
__p += '\n    <form name="' +
((__t = ( 'COMPAT_' + compat.name )) == null ? '' : __t) +
'" class="sponsors_config" onsubmit="return false">\n      ';
 _.each(compat.map, function(model, name){ ;
__p += '\n        ';
 if (model.value || model.text) { ;
__p += '\n        <input type="hidden" name="' +
((__t = ( model.correodirectBinding )) == null ? '' : __t) +
'" value="' +
((__t = ( model.value || model.text )) == null ? '' : __t) +
'" />\n        ';
 } else {
          var translationKey = model.translationKey
          if (translationKey) translationKey += ("_" + language)
        ;
__p += '\n        <input type="hidden" name="' +
((__t = ( model.correodirectBinding )) == null ? '' : __t) +
'" data-i18n="[value]' +
((__t = ( translationKey )) == null ? '' : __t) +
'" value="">\n        ';
 } ;
__p += '\n      ';
 }) ;
__p += '\n    </form>\n  ';
 }) ;
__p += '\n  <form name="INTEGRATION_Styles" class="sponsors_config" onsubmit="return false">\n    <input type="hidden" name="100%" value="TableWidth">\n    <input type="hidden" name="0" value="TableCellpadding">\n    <input type="hidden" name="10" value="TableCellspacing">\n    <input type="hidden" name="0" value="TableBorder">\n    <input type="hidden" name="ecf3f7" value="TableBgcolor">\n    <input type="hidden" name="center" value="TableAlign">\n    <input type="hidden" name="Arial, Helvetica, sans-serif" value="TextFace">\n    <input type="hidden" name="1" value="TextSize">\n    <input type="hidden" name="000000" value="TextColor">\n    <input type="hidden" name="Arial, Helvetica, sans-serif" value="TitleFace">\n    <input type="hidden" name="4" value="TitleSize">\n    <input type="hidden" name="156568" value="TitleColor">\n    <input type="hidden" name="center" value="TitleAlign">\n    <input type="hidden" name="450" value="TextboxWidth">\n  </form>\n  <form name="INTEGRATION_Data" class="sponsors_config" onsubmit="return false">\n    ';
 _.each(integrationData, function(value, name){;
__p += '\n      <input type="hidden" name="' +
((__t = ( name )) == null ? '' : __t) +
'" value="' +
((__t = ( value )) == null ? '' : __t) +
'">\n    ';
 }) ;
__p += '\n  </form>\n</div>\n\n<div id=\'sponsors_validation\' class="form-validation-overlay js-sponsors-validation" style="display:none">\n  <span class="close"></span>\n  <h2 data-i18n="' +
((__t = ( 'common.formError_' + language )) == null ? '' : __t) +
'">Por favor, corrija los siguientes errores:</h2>\n  <ul class="js-sponsors-error-list"></ul>\n</div>\n';
};
__p += '\n';

}
return __p
};});

